import cn from 'classnames';
import React from 'react';
import type { Poll } from 'schema/poll';
import { Progress } from '../../../../types/domain';
import { inIframe } from '../../../../utils/location';
import { ContentWrapper } from '../ContentWrapper';
import { Header } from '../Header';
import { RootWrapper } from '../RootWrapper';
import styles from './QuestionWrapperTemplate.module.css';

export interface QuestionWrapperTemplateProps {
  title: string | null;
  children: React.ReactNode;
  footer: React.ReactNode;
  progressBar: NonNullable<Poll['progressBar']>;
  isWebview: boolean;
  hasWelcome: boolean;
  showBackButton: boolean;
  progress: Progress;
  onBack: VoidFunction;
  onClose: VoidFunction;
  alignSurvey: 'left' | 'center';
}

export const QuestionWrapperTemplate: React.FC<QuestionWrapperTemplateProps> = ({
  title,
  children,
  isWebview,
  hasWelcome,
  footer,
  onBack,
  onClose,
  progress,
  progressBar,
  showBackButton,
  alignSurvey,
}) => {
  return (
    <div className={cn(styles.container, { [c(styles.iframe)]: inIframe() })}>
      <RootWrapper className={styles.container}>
        <Header
          className={styles.header}
          title={title}
          isWebview={isWebview}
          hasWelcome={hasWelcome}
          onBack={onBack}
          onClose={onClose}
          showBackButton={showBackButton}
          progress={{ ...progress, type: progressBar }}
          alignSurvey={alignSurvey}
        />

        <ContentWrapper>{children}</ContentWrapper>

        {footer && <div className={styles.footer}>{footer}</div>}
      </RootWrapper>
    </div>
  );
};
